import React from 'react';
import _ from 'lodash';

const MetaTags = ({ node }) => {
  let title = null
  let description = null

  return (
    <>
      {_.map(node.entityMetatags, metatag => {
        switch (metatag.key) {
          case 'title':
            title = metatag.value;
            return <title key={metatag.key}>{metatag.value}</title>;
          case 'description':
          case 'abstract':
            if (metatag.key == 'description') {
              description = metatag.value;
            }
            return (
              <meta
                key={metatag.key}
                name={metatag.key}
                content={metatag.value}
              />
            );
          default:
            return null;
        }
      })}

      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={`${process.env.GATSBY_BASE_URL}${node.path.alias}`}
      />
      <meta
        property="og:image"
        content={`${process.env.GATSBY_BASE_URL}/logo.svg`}
      />
      {description && <meta property="og:description" content={description} />}
    </>
  );
}

export default MetaTags;
